import { render, staticRenderFns } from "./AiDataSourceInvokePanel.vue?vue&type=template&id=12ff82dc&scoped=true"
import script from "./AiDataSourceInvokePanel.vue?vue&type=script&lang=js"
export * from "./AiDataSourceInvokePanel.vue?vue&type=script&lang=js"
import style0 from "./AiDataSourceInvokePanel.vue?vue&type=style&index=0&id=12ff82dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff82dc",
  null
  
)

export default component.exports